import { action, makeObservable, observable } from 'mobx';

import { ModalPayloadMap } from './type';

type ModalName =
  | 'addLog'
  | 'editLog'
  | 'addDraft'
  | 'editDraft'
  | 'copyLog'
  | 'deleteLog'
  | 'stats'
  | 'settings'
  | 'filter'
  | 'caldav';

export class ModalManagerStore {
  openModal: ModalName | null = null;

  payload: ModalPayloadMap[keyof ModalPayloadMap] = null;

  constructor() {
    makeObservable(this, {
      openModal: observable,
      payload: observable,
      open: action.bound,
      close: action.bound,
      isOpen: action.bound,
    });
  }

  open<T extends ModalName>(name: T, payload?: ModalPayloadMap[T]) {
    this.openModal = name;
    this.payload = payload || null;
  }

  close() {
    this.openModal = null;
    this.payload = null;
  }

  isOpen<T extends ModalName>(name: T): this is { payload: ModalPayloadMap[T] } {
    return this.openModal === name;
  }
}

export const modalManagerStore = new ModalManagerStore();
